// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2U7PR","gfeWrapper":"CalendarEvent_gfeWrapper__uTefA"};